// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_auth_signup_signup_component_ts":"19ea3ac2e39eed1a","src_app_auth_otp_otp_component_ts":"dd1c0bbef49493da","src_app_auth_details_details_component_ts":"9f944e99c1ca1494","src_app_screens_patients_patients_module_ts":"56f43800f2e6613f"}[chunkId] + ".js";
};